module.exports = __webpack_public_path__ + "static/logo-cc4e965bf6bbea10e48aa1f8ee9f0544.png";